module.exports = __webpack_public_path__ + "static/media/TxMante.81b41d7d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/TxMante.svg
// module id = 215
// module chunks = 0